import AddUserSalesPage from "../../../component/users/sales/AddUserSalesPage"

  
 
function EditUserSales() {
  return (
    <div className="page-body">
      <AddUserSalesPage/>
      </div>
  )
}

export default EditUserSales